import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../selectors/page';

function getIsMainPage(): boolean {
  return window.location.pathname === '/' && !window.location.hostname.startsWith('my.');
}

function canUseWindow(): boolean {
  return typeof window !== 'undefined';
}

export function useIsMainPage(): boolean {
  const pageType = useSelector(selectPageType);
  const [isMainPage, setIsMainPage] = useState(() => (canUseWindow() ? getIsMainPage() : pageType === 'main'));

  useEffect(() => {
    const update = () => setIsMainPage(getIsMainPage());

    update();

    window.addEventListener('popstate', update);

    const originalPushState = history.pushState.bind(history);
    const originalReplaceState = history.replaceState.bind(history);

    history.pushState = (...args: Parameters<History['pushState']>) => {
      originalPushState(...args);
      update();
    };

    history.replaceState = (...args: Parameters<History['replaceState']>) => {
      originalReplaceState(...args);
      update();
    };

    return () => {
      window.removeEventListener('popstate', update);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  return isMainPage;
}
